<template>
  <div class="app">
    <div class="app__header">
      <VBlock max-width="379px">
        <img src="@/assets/app-logo.png" />
      </VBlock>
    </div>

    <div class="app__content">
      <transition name="fade" mode="out-in" appear>
        <router-view :key="$route.fullPath" v-if="!isLoading" />
      </transition>
    </div>

    <img class="app__artwork" src="@/assets/app-artwork.png" />

    <a class="app__footer" href="https://www.youtube.com/@PRZYGODY_PUFKA?sub_confirmation=1" target="_blank">
      <VBlock>
        <img src="@/assets/app-footer.png" />
      </VBlock>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { RESET_LOADING, BEGIN_LOADING, END_LOADING } from '@/store';
import config from '@/config';

export default {
  name: 'App',

  created() {
    const { languageCode } = config;

    this.$store.commit(RESET_LOADING);

    this.loadDictionary(languageCode);
  },

  computed: {
    ...mapGetters([
      'isLoading',
    ]),
  },

  methods: {
    async loadDictionary(languageCode) {
      const FAKE_DELAY = 500;

      this.$store.commit(BEGIN_LOADING);

      this.$i18n.setLocaleMessage(
        languageCode,
        (await this.$bricodes.getDictionary(languageCode)).data,
      );

      this.$i18n.locale = languageCode;

      setTimeout(() => {
        this.$store.commit(END_LOADING);
      }, FAKE_DELAY);
    },
  },
};
</script>

<style lang="scss">
@import 'reset-css';
@import '~vue2-animate/dist/vue2-animate.min.css';
@import '~animate.css/animate.min.css';

@font-face {
  font-family: 'Roboto Condensed';
  src: url('~@/assets/RobotoCondensed-Bold.woff2') format('woff2'),
    url('~@/assets/RobotoCondensed-Bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Bangers';
  src: url('~@/assets/Bangers-Regular.woff2') format('woff2'),
    url('~@/assets/Bangers-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

body {
  background-image: url('~@/assets/body-background-center.png'), url('~@/assets/body-background-cover.jpg');
  background-repeat: no-repeat, no-repeat;
  background-size: auto auto, cover;
  background-attachment: fixed, fixed;
  background-position: top center, center center;
}

.app {
  // overflow: hidden;
  position: relative;

  display: flex;
  flex-direction: column;

  min-height: 100%;
  max-width: $appWidth;
  margin: 0 auto;

  font-family: Arial, Helvetica, sans-serif;
  font-size: font(18px, 40px);

  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 172px;
    margin: $gridGutter;

    background-image: url('~@/assets/app-header-artwork.png');
    background-repeat: no-repeat;
    background-position: left center;

    @media screen and (max-width: 900px) {
      background-image: none;
    }
  }

  &__content {
    overflow: hidden;
    flex: 1 1 auto;

    background-color: #b09e89;
    background-image: url('~@/assets/app-background.png');
    background-repeat: repeat-y;
    background-size: 100% auto;
    background-position: top center;

    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    border-radius: 20px 20px 0 0;
  }

  &__artwork {
    position: absolute;
    top: 70px;
    right: 30px;
    user-select: none;

    @media screen and (max-width: 900px) {
      display: none;
    }
  }
}
</style>
